import React from 'react';
import DragHandleIcon from './DragHandleIcon';
import tableStyles from './tableStyles';

interface Column {
  id: string;
  label: string;
}

interface DragOverlayHeaderProps {
  column: Column;
}

const DragOverlayHeader: React.FC<DragOverlayHeaderProps> = ({ column }) => (
  <div style={tableStyles.overlayPill}>
    <DragHandleIcon />
    {column.label}
  </div>
);

export default DragOverlayHeader;
